import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationSettingsFn = /* @__PURE__ */ createRecipe('anchor-navigation-settings', {}, [])

const anchorNavigationSettingsVariantMap = {
  "variant": [
    "primary",
    "secondary",
    "tertiary"
  ]
}

const anchorNavigationSettingsVariantKeys = Object.keys(anchorNavigationSettingsVariantMap)

export const anchorNavigationSettings = /* @__PURE__ */ Object.assign(memo(anchorNavigationSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationSettings',
  __getCompoundVariantCss__: anchorNavigationSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationSettingsVariantKeys,
  variantMap: anchorNavigationSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationSettingsVariantKeys)
  },
  getVariantProps: anchorNavigationSettingsFn.getVariantProps,
})